export var MediaType;
(function (MediaType) {
    MediaType[MediaType["PHOTO"] = 'PHOTO'] = "PHOTO";
    MediaType[MediaType["VIDEO"] = 'VIDEO'] = "VIDEO";
})(MediaType || (MediaType = {}));
//# sourceMappingURL=media-item.js.map